import type { PersonNames } from '../personnel/usePersonNames';

/**
 * What a nominee's name cell says, including when it cannot say a name. **Restricted is tested
 * FIRST, off the ABSENCE of the id** — the server withholds `personId` for an employee above the
 * reader's clearance, so there is nothing to resolve. Null while the batch is in flight.
 */
export function nomineeName(personId: string | null | undefined, names: PersonNames): string | null {
  // `== null`: a nullable wire field arrives as `undefined`.
  if (personId == null) return 'Restricted';
  if (names.statusOf(personId) === 'erased') return 'Identity erased';

  return names.nameOf(personId) ?? (names.failed ? 'Name unavailable' : null);
}
